Vendd.Scripts.load(function () {

    var $wrapper = $('.x-store-locator'), wrapper,
        $form, form, $stores, stores, $map, map,
        currentState, state;

    var formmodel = null, storemodel = null;

    var searchCoordinates = {}; 

    var run = function () { 
        
        if ($wrapper.length < 1)
            return false;

        $form = $('.x-store-locator-form', $wrapper);
        $stores = $('.x-store-locator-stores', $wrapper);
        $map = $('.x-google-map', $wrapper);

        wrapper = $wrapper.get(0);
        form = $form.get(0);
        stores = $stores.get(0);
        map = $map.get(0);

        //scroll to stores button 
        scrollToStoresArea();

        function scrollToStoresArea() {

            var scrollButton = $('.js-scroll-to', $wrapper);

            if (scrollButton.length < 1) return;

            var scrollTopValue = $map.height() - $('.header-region').height();

            scrollButton.click(function (e) {
                e.preventDefault();
                $('html,body').animate({
                    scrollTop: scrollTopValue
                }, 800);

            });
        }

        if (typeof form == 'undefined')
            return false;

        currentState = {
            ItemId: LhApp.Context.Item.Id,
            ItemCode: '',
            ShopIncludedDelivery: 0,
            CountryCode: $('select[name="country"]', $form).length > 0 ? $('select[name="country"]', $form).val() : '',
            Continent: $('select[name="continent"]', $form).length > 0 ? $('select[name="continent"]', $form).val() : '',
            City: $('select[name="city"]', $form).length > 0 ? $('select[name="city"]', $form).val() : '',
            Area: $('select[name="area"]', $form).length > 0 ? $('select[name="area"]', $form).val() : '',
            TypeId: $('select[name="type"]', $form).length > 0 ? parseInt($('select[name="type"]', $form).val(), 10) : 0,
            PostCode: $('input[name="postCode"]', $form).length > 0 ? $('input[name="postCode"]', $form).val() : '',
            SearchTerm: $('input[name="search"]', $form).length > 0 ? $('input[name="search"]', $form).val() : '',
            MaxDistance: 1000000000,
            GeoAreaId: '',
            SiteId: null,
            Latitude: '',
            Longitude: '',       
        };

        state = $.extend(true, {}, currentState);

        Vendd.Store.Controller.initState(currentState);

        form.loading = function (loading) {
            if (loading) {
                $form.addClass('x-loading');
            } else {
                $form.removeClass('x-loading');
            }
        };

        form.resetFilters = function () {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.resetFilters());
        };

        form.resetGeoLocation = function () {
            currentState.GeoAreaId = '';
            currentState.Latitude = '';
            currentState.Longitude = '';

            searchCoordinates = { lat: '', lng: '' };
        };

        form.submit = function () {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.QueryPartners(currentState));
        };

        form.savePosition = function (position) {
            searchCoordinates = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };

            currentState.GeoAreaId = '';
            currentState.Latitude = searchCoordinates.lat;
            currentState.Longitude = searchCoordinates.lng;

            if (currentState.Continent != "" || currentState.CountryCode != "" || currentState.City != "" || currentState.Area != "") {
                //if there is filter about location, reset filters and then call service for partners
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.resetLocationFilters());
            } else {
                //else call service for partners direct
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.QueryPartners(currentState));
            }                     
        };

        form.update = function () {
            var html = Vendd.Handlebars.parse("storeLocatorForm_A", formmodel);

            $form.html(html);

            var newState = Vendd.Store.Controller.getState();

            currentState.CountryCode = newState.CountryCode;
            currentState.City = newState.City;
            currentState.Area = newState.Area;
            currentState.TypeId = newState.TypeId;

            if (currentState.SearchTerm != "" || currentState.Continent != "" || currentState.CountryCode != "" || currentState.City != "" || currentState.Area != "" || currentState.TypeId != 0 || currentState.PostCode != "") {
                $('.button-wrapper.clear', $form).show();
            }

            form.submit();

            form.loading(false);
        };

        form.updateMap = function () {

            if (!searchCoordinates.lat || !searchCoordinates.lng) return;

            var bounds = new google.maps.LatLngBounds();

            geoLocationCordinates = new google.maps.LatLng(searchCoordinates.lat, searchCoordinates.lng);
            bounds.extend(geoLocationCordinates);

            nearestStoreCoordinates = new google.maps.LatLng($('.x-partner-box', $stores).eq(0).data('latitude'), $('.x-partner-box', $stores).eq(0).data('longitude'));
            bounds.extend(nearestStoreCoordinates);

            map.map.fitBounds(bounds);
            map.map.setCenter(searchCoordinates);

            var zoom = map.map.getZoom();
            if (zoom > 13) zoom = 13;
            if (zoom < 4) zoom = 4;

            map.map.setZoom(zoom);
        };

        form.updateSearchResults = function (data) {
            if (data.model.length < 1) {
                $('.x-store-locator-search-results', $form).hide();
                return;
            } 

            var html = Vendd.Handlebars.parse("storeLocatorFormSearchResults_A", data);

            $('.x-store-locator-search-results', $form).html(html).show();
        };

        stores.loading = function (loading) {
            if (loading) {
                $stores.addClass('x-loading');
            } else {
                $stores.removeClass('x-loading');
            }
        };

        stores.bind = function () {
            
            var $storesList = $('.x-partner-list', $stores),
                $partners = $('.x-partner-box', $storesList),
                coordinates = [];

            $.each($partners, function (i, partner) {
                var $partner = $(partner),
                    coord = {
                        lat: $partner.data('latitude'),
                        lng: $partner.data('longitude'),
                        html: $('.box-info', $partner).html()
                    };

                if (coord.lat !== '' && coord.lng !== '') {
                    coordinates.push(coord);
                }
            });

            if (map.markers.length > 0) {
                map.removeMarkers();
                map.reinit(coordinates);
            } else {
                if (coordinates.length > 0) {
                    map.create(coordinates);
                }
            }         

            //use function for google search
            if ($('.js-google-search', $form).length > 0) {
                googleSearch();
            } 

            if ($('.x-partner-list', $stores).hasClass('x-accordion')) {
                initAccordion($partners);
            }

            if ($('.x-partner-list', $stores).hasClass('x-slider')) {

                $storesList.on('destroy', function (event, slider, direction) {
                    initAccordion($partners);
                });
            }

            if ($map.length > 0) {
                initMapHeight($map);

                $(window).resize($.debounce(500, function () {
                    initMapHeight($map);
                }));
            }
        };

        stores.update = function () {
            var component = $wrapper.data('component');
            var html = Vendd.Handlebars.parse(component, storemodel);

            $stores.html(html);

            stores.bind();

            if (currentState.SearchTerm != "" || currentState.Continent != "" || currentState.CountryCode != "" || currentState.City != "" || currentState.Area != "" || currentState.TypeId != 0 || currentState.PostCode != "") {
                $stores.addClass('show-results');
            } else {
                $stores.removeClass('show-results');
            }

            state = $.extend(true, {}, currentState);

            //update map with user's location data
            form.updateMap();

            stores.loading(false);
        };

        $form.on('change', 'select[name="continent"]', function (e) {
            form.loading(true);
            form.resetGeoLocation();

            var continent = $(this).val();
            currentState.Continent = continent;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetContinent(continent));
        });

        $form.on('change', 'select[name="country"]', function (e) {
            form.loading(true);
            form.resetGeoLocation();

            var country = $(this).val();
            currentState.CountryCode = country;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetCountry(country));
        });

        $form.on('change', 'select[name="city"]', function (e) {
            form.loading(true);
            form.resetGeoLocation();

            var city = $(this).val();
            currentState.City = city;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetCity(city));
        });

        $form.on('change', 'select[name="area"]', function (e) {
            form.loading(true);
            form.resetGeoLocation();

            var area = $(this).val();
            currentState.Area = area;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetArea(area));
        });

        $form.on('change', 'select[name="type"]', function (e) {
            form.loading(true);

            var type = parseInt($(this).val(), 10);

            currentState.TypeId = type;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetType(type));
        });   

        $form.on('keyup', '.js-keyword', $.debounce(500, function (e) {
            e.stopPropagation();

            var $this = $(this);
            var searchTerm = $this.val();

            if (searchTerm.length < 1) {
                $this.closest('.input-wrapper').siblings('.x-store-locator-search-results').empty().hide();
                return;
            } 

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SearchResults(searchTerm));            
        }));

        $form.on('focus', '.js-keyword', function (e) {
            if ($('.x-store-locator-search-results > ul > li', $form).length > 0) {
                $('.x-store-locator-search-results', $form).show();
            }
        });

        $(document).click(function (event) {
            if (!$(event.target).hasClass('js-keyword')) {
                $('.x-store-locator-search-results', $form).hide();
            }
        });

        $form.on('click', '.js-select-item', function (e) {
            e.preventDefault();
            e.stopPropagation();

            stores.loading(true);

            var $this = $(this);

            //trim value
            var $trimValue = "";
            var $value = $this.find('span');

            $value.each(function (index) {
                $trimValue = $trimValue + $.trim($(this).text());
            });

            $this.closest('.x-store-locator-search-results').hide();
            $this.closest('.x-store-locator-search-results').siblings('.input-wrapper').find('.js-keyword').val($trimValue);

            searchCoordinates = {
                lat: $(this).data('lat'),
                lng: $(this).data('lon')
            };

            currentState.GeoAreaId = $(this).data('geoareaid');
            currentState.Latitude = '';
            currentState.Longitude = '';

            if (currentState.Continent != "" || currentState.CountryCode != "" || currentState.City != "" || currentState.Area != "") {
                //if there is filter about location, reset filters and then call service for partners
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.resetLocationFilters());
            } else {
                //else call service for partners direct
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.QueryPartners(currentState));
            }     
        });

        $form.on('click', '.js-reset', function (e) {
            e.preventDefault();
            e.stopPropagation();

            form.loading(true);

            form.resetFilters();
        });

        $form.on('click', '.js-use-geolocation', function (e) {
            e.preventDefault();
            e.stopPropagation();

            stores.loading(true);

            if (window.navigator.geolocation) {
                window.navigator.geolocation.enableHighAccuracy = false;
                window.navigator.geolocation.getCurrentPosition(form.savePosition, errorCallback);
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        });

        $('.x-partner-box .find-on-map-btn').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                coords, marker;

            coords = {
                lat: $this.closest('.x-partner-box').data('latitude'),
                lng: $this.closest('.x-partner-box').data('longitude')
            };

            marker = $map.get(0).getMarker(coords);

            if (marker) {
                $map.get(0).open(marker);
                $('html, body').animate({ scrollTop: $map.offset().top - 100 }, 500);
            }
        });     

        return true;
    };

    function initAccordion($partners) {
        $partners.on('click', '.js-info-toggle-btn', function (e) {
            var $this = $(this);
            var partner = $this.closest('.x-partner-box');
            var iconOpen = $this.data('open-icon');
            var iconClose = $this.data('close-icon');
            prevOpened = $this.closest('.x-partner-list').find('.x-partner-box.opened');
            if (!partner.hasClass('opened')) {
                prevOpened.find('.js-info-toggle-btn').toggleClass(iconOpen + ' ' + iconClose);
                prevOpened.removeClass('opened');
            }
            partner.toggleClass('opened');
            $this.toggleClass(iconOpen + ' ' + iconClose);
        });
    }

    function errorCallback(error) {
        var message = "";
        // Check for known errors 
        switch (error.code) {
            case error.PERMISSION_DENIED:
                message = "This website does not have permission to use " +
                    "the Geolocation API";
                break;
            case error.POSITION_UNAVAILABLE:
                message = "The current position could not be determined.";
                break;
            case error.PERMISSION_DENIED_TIMEOUT:
                message = "The current position could not be determined " +
                    "within the specified timeout period.";
                break;
        }

        if (message == "") {
            var strErrorCode = error.code.toString();
            message = "The position could not be determined due to " +
                "an unknown error (Code: " + strErrorCode + ").";
        }
    } 

    //use google search and get the coordinates from google results
    function googleSearch() {
        var input = document.getElementById("google-search-input");
        //google search for specific countries
        //var options = { componentRestrictions: { country: ['us', 'gr'] } };

        var autocomplete = new google.maps.places.Autocomplete(input/*, options*/);

        autocomplete.addListener("place_changed", function () {
            var place = autocomplete.getPlace();

            if (typeof place.geometry === 'undefined') return;

            //get coordinates
            var position = {
                coords: {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng()
                }
            };
            //return in the main flow
            //using the coordinates from google search
            form.savePosition(position);
        });
    }

    function initMapHeight(map) {

        if ($(window).outerWidth() < 768) return;

        var $formContainer = $('.form-container', $wrapper);
        var formHeight = $formContainer.height() || 0;

        map.height(formHeight);
 
    }

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.UpdateForm, wrapper, function (envelope) {
        formmodel = envelope.message.data.model;
        form.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.GoogleMapsLoaded, 'storesMap', function () {
        if (run()) {
            stores.bind();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SearchResultsSuccess, wrapper, function (envelope) {
        form.updateSearchResults(envelope.message.data);      
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.QueryPartnersSuccess, wrapper, function (envelope) {
        storemodel = envelope.message.data.model;
        stores.update();
    });
    
});